import React from 'react'
import PropTypes from 'prop-types'
import { graphql, Link } from 'gatsby'
import styled from 'styled-components'
import parse from 'html-react-parser'
import Img from 'gatsby-image'
import { device } from '../components/Breakpoints'
import { Breadcrumb } from '../components/Breadcrumb'
import { colors } from '../components/Colors'
import PageHeader from '../components/PageHeader'
import icongestante from '../icons/icon-gestante.svg'
import iconpezinho from '../icons/icon-pezinho.svg'
import iconrefeicao from '../icons/icon-refeicao.svg'
import iconvacina from '../icons/icon-vacina.svg'
import iconwifi from '../icons/icon-wifi.svg'
import Layout from '../components/Layout'
import VejaTambem from '../components/VejaTambem'
import CentralAtendimento from '../components/CentralAtendimento'

const Container = styled.section`
  width: 100%;
  margin-bottom: 2em;
`

const GroupContent = styled.section`
  padding: 2em 0;
  a {
    color: ${colors.lilas};
  }
  h3 {
    color: ${colors.lilas};
    position: relative;
    margin: 0;
    font-size: 1em;
    padding: 1.5em;
    padding-right: 0em;
    :before {
      position: absolute;
      content: '';
      top: 15px;
      left: 28px;
      border: 1px solid ${colors.lilas};
      width: 5%;
      opacity: 0.5;
      @media ${device.mobileL} {
        left: 22px;
      }
    }
    :after {
      position: absolute;
      content: '';
      bottom: 15px;
      left: 28px;
      border: 1px solid ${colors.lilas};
      width: 5%;
      opacity: 0.5;
      @media ${device.mobileL} {
        left: 22px;
      }
    }
    @media ${device.mobileL} {
      padding: 2em 5px 2em 1em;
    }
  }
  .lista {
    h4 {
      margin-top: 4em;
    }
    ul {
      padding: 0;
      margin: 2em 0 0;
      display: flex;
      flex-wrap: wrap;

      li {
        display: flex;
        margin: 0 1em 1em 0;
        padding: 0.8em 1.5em 0.8em 1.5em;
        list-style: none;
        background: #ffffff;
        box-shadow: 2px 2px 6px rgba(0, 0, 0, 0.4);
        position: relative;
        min-height: 40px;
        box-sizing: border-box;
        width: 47%;
        p {
          margin: 0;
        }
        @media ${device.mobileL} {
          width: 100%;
          padding: 0.8em 1.5em;
          margin: 0 0 1em 0;
        }
        img {
          min-width: 56px;
          @media all and (-ms-high-contrast: none),
            (-ms-high-contrast: active) {
            margin-top: 14px;
          }
        }
        svg {
          position: absolute;
          left: 25px;
          top: 15px;
          font-size: 1.8em;
          color: ${colors.verde};
          @media all and (-ms-high-contrast: none),
            (-ms-high-contrast: active) {
            top: 10px !important;
          }
        }
      }
    }
  }
  :nth-of-type(2) {
    background: ${colors.lilasGradiente};
    color: #ffffff;
  }
  @media ${device.mobileL} {
    padding: 2em;
    p,
    h3 {
      text-align: left;
    }
  }
`

export const ServicosOpcionaisTemplate = ({
  title,
  content,
  slug,
  image,
  color,
  area = 'Centros e Serviços',
  sessoes,
}) => {
  const crumbs = [
    { id: 1, link: '/', title: 'Home', icon: true },
    { id: 2, link: '#', title: area, icon: true },
    { id: 3, link: slug, title },
  ]
  return (
    <>
      <Container>
        <Breadcrumb crumbs={crumbs} />

        <PageHeader
          title={title}
          content={content}
          image={image}
          color={color}
          txtColor="cinza"
          height="180px"
          right="0"
          bottom="0"
          imgWidth="46%"
          overflow="visible"
          imgInner
          mobileTop="-21%"
        />
        <GroupContent>
          <div className="center">
            <div>
              {parse(sessoes[0].texto)}
              <div className="lista">
                <ul>
                  <li>
                    <img src={iconpezinho} alt="Equipe multidisciplinar" />
                    <a
                      href={parse(sessoes[1].links[0].url)}
                      title=""
                      target="_blank"
                      rel="noopener noreferrer"
                    >
                      <h3>{parse(sessoes[1].links[0].tituloLink)}</h3>
                    </a>
                  </li>
                  <li>
                    <img src={iconpezinho} alt="Equipe multidisciplinar" />
                    <a
                      href={parse(sessoes[2].links[0].url)}
                      title=""
                      target="_blank"
                      rel="noopener noreferrer"
                    >
                      <h3>{parse(sessoes[2].links[0].tituloLink)}</h3>
                    </a>
                  </li>
                  <li>
                    <img src={iconvacina} alt="Equipe multidisciplinar" />
                    <a
                      href={parse(sessoes[3].links[0].url)}
                      title=""
                      target="_blank"
                      rel="noopener noreferrer"
                    >
                      <h3>{parse(sessoes[3].links[0].tituloLink)}</h3>
                    </a>
                  </li>
                  <li>
                    <img src={iconwifi} alt="Equipe multidisciplinar" />
                    <h3>{parse(sessoes[4].tituloDaSessao)}</h3>
                  </li>
                  <li>
                    <img src={icongestante} alt="Equipe multidisciplinar" />
                    <a
                      href={parse(sessoes[5].links[0].url)}
                      title=""
                      target="_blank"
                      rel="noopener noreferrer"
                    >
                      <h3>{parse(sessoes[5].links[0].tituloLink)}</h3>
                    </a>
                  </li>
                  <li>
                    <img src={iconrefeicao} alt="Equipe multidisciplinar" />
                    <h3>{parse(sessoes[6].tituloDaSessao)}s</h3>
                  </li>
                </ul>
              </div>
              {parse(sessoes[7].texto)}
            </div>
          </div>
        </GroupContent>
        <CentralAtendimento />
      </Container>
    </>
  )
}

ServicosOpcionaisTemplate.propTypes = {
  title: PropTypes.string.isRequired,
  content: PropTypes.string,
}

const ServicosOpcionais = ({ data, location }) => {
  const { siteMetadata: site } = data.site
  const { wpPage: page } = data
  const image = page.opEsDaPGina.imagem ? page.opEsDaPGina.imagem.sourceUrl : ''
  const area = location.state ? location.state.area : page.opEsDaPGina.area
  const { paginasRelacionadas } = page.opEsDaPGina
  const { sessaoCustomizada: sessoes } = page.SessoesCustomizadas
  const description = page.excerpt
    ? page.excerpt.replace(/<\/?[^>]+(>|$)/g, '').replace(/\n/g, '')
    : ''

  return (
    <Layout title={`${page.title} – ${site.title}`} description={description}>
      <ServicosOpcionaisTemplate
        title={page.title}
        content={page.content}
        image={image}
        slug={page.slug}
        color={page.opEsDaPGina.corDoCabecalho}
        area={area}
        sessoes={sessoes}
      />
      <VejaTambem relatedPages={paginasRelacionadas} />
    </Layout>
  )
}

ServicosOpcionais.propTypes = {
  data: PropTypes.object.isRequired,
}

export default ServicosOpcionais

export const ServicosOpcionaisQuery = graphql`
  query ServicosOpcionaisById($id: String!) {
    site {
      siteMetadata {
        url
        title
      }
    }
    wpPage(id: { eq: $id }) {
      title
      content
      slug
      excerpt
      SessoesCustomizadas {
        sessaoCustomizada {
          listaDeItens {
            item
          }
          texto
          tituloDaSessao
          imagemDaSessao {
            sourceUrl
            localFile {
              childImageSharp {
                fluid {
                  ...GatsbyImageSharpFluid_withWebp
                }
              }
            }
          }
          links {
            tituloLink
            url
          }
        }
      }
      opEsDaPGina {
        corDoCabecalho
        area
        imagem {
          sourceUrl
        }
        paginasRelacionadas {
          ... on WpPage {
            id
            title
            slug
          }
        }
      }
    }
  }
`
